import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

export default function SellingProposition() {
  return (<div className='selling-proposition'>
    <div className='selling-proposition__item'>
      <div className='selling-proposition__icon'>
        <span className='circle-icon red'>
          <i className='font-icons discount-icon' />
        </span>
      </div>
      <div className='selling-proposition__item__content'>
        <FormattedHTMLMessage id='selling_propostion.best_price' defaultMessage="<strong class='red-text'>BEST PRICE GUARANTEE</strong> we match any competitor’s price." />
      </div>
    </div>
    <div className='selling-proposition__item'>
      <div className='selling-proposition__icon'>
        <span className='circle-icon blue'>
          <i className='font-icons icon-insurance' />
        </span>
      </div>
      <div className='selling-proposition__item__content'>
        <FormattedHTMLMessage id='selling_propostion.benefits' defaultMessage="<strong class='blue-text'>EXCLUSIVE BENEFITS</strong> such as free DAN dive insurance." />
      </div>
    </div>
    <div className='selling-proposition__item'>
      <div className='selling-proposition__icon'>
        <span className='circle-icon green'>
          <i className='font-icons phone-icon' />
        </span>
      </div>
      <div className='selling-proposition__item__content'>
        <FormattedHTMLMessage id='selling_propostion.support' defaultMessage="<strong class='green-text'>24/7 EXPERT DIVING ADVICE</strong> from travel agents who are all divers." />
      </div>
    </div>
    <div className='selling-proposition__item'>
      <div className='selling-proposition__icon'>
        <img src={window.staticPath + 'travel_dist/images/logo_padi_dark.svg'} className='hidden-xs hidden-sm' />
        <img src={window.staticPath + 'travel_dist/images/padi_logo.svg'} className='hidden-md hidden-lg' />
      </div>
      <div className='selling-proposition__item__content'>
        <FormattedMessage id='selling_propostion.we_are_padi' defaultMessage='Book in full confidence. We are PADI, the leader in diving.' />
      </div>
    </div>
  </div>)
}
